import KEYCODES from 'common/KeyCodes';

const { TAB, ESCAPE, ENTER_KEY, SPACE_KEY } = KEYCODES;

const toggleMenu = (event, isOpen, onClose, onOpen) => {
  if (isOpen) {
    onClose && onClose(event);
  } else {
    onOpen && onOpen(event);
  }
};

const handleMenuCloseCallback = (event, setClickedOutside, onClose) => {
  setClickedOutside(false);
  const { key, type } = event;
  if (key === TAB) {
    event.preventDefault();
  }
  if (type === 'mousedown') {
    // clicked outside. do not focus selectitem
    setClickedOutside(true);
  }
  onClose && onClose(event);
};

const handleListKeyDown = (event, onClose, externalKeyDown = undefined) => {
  const { key } = event;
  switch (key) {
    case ESCAPE:
      onClose && onClose(event);
      break;
    case TAB:
    case ENTER_KEY:
    case SPACE_KEY:
      onClose && onClose(event);
      event.preventDefault();
      break;
    default:
      break;
  }

  externalKeyDown && externalKeyDown(event);
};

const handleFocus = (event, onFocus, setClickedOutside, setIsFocused) => {
  setClickedOutside(false);
  setIsFocused(true);
  onFocus && onFocus(event);
};

const handleBlur = (event, onBlur, setClickedOutside, setIsFocused) => {
  setClickedOutside(false);
  setIsFocused(false);
  onBlur && onBlur(event);
};

const handleMouseOver = (event, onMouseOver, setIsHovered) => {
  setIsHovered(true);
  onMouseOver && onMouseOver(event);
};
const handleMouseLeave = (event, onMouseLeave, setIsHovered) => {
  setIsHovered(false);
  onMouseLeave && onMouseLeave(event);
};

const scrollToSelectedItem = (selectedDiv) => {
  // scroll to any selected item
  const parentEl = selectedDiv && selectedDiv.parentElement;
  const scrollingParentEl = parentEl && parentEl.parentElement;
  if (parentEl) {
    // need this type of scrolling since scrollIntoView will scroll the whole page making
    // the entire browser content appear to be jumping.
    const { x: parentX } = parentEl.getBoundingClientRect() || {};
    const { height: selectedElHeight, bottom: selectedElBottom } = selectedDiv.getBoundingClientRect() || {};
    // subtract (2 * selectedElHeight )so the sticky headers, if any, do not hide the selected item
    scrollingParentEl && scrollingParentEl.scrollTo(parentX, selectedElBottom - (2 * selectedElHeight));
  }
};

export {
  toggleMenu,
  handleMenuCloseCallback,
  handleListKeyDown,
  handleFocus,
  handleBlur,
  handleMouseOver,
  handleMouseLeave,
  scrollToSelectedItem,
};